import {axiosInstance} from "./AxiosInstance";
import {createSearchParams, NavigateFunction} from "react-router-dom";
import {ROUTE_POST_LOGIN, ROUTE_POST_LOGOUT} from "../constants";


export const useAxiosInterceptors = (navigate: NavigateFunction) => {

    // clear request interceptor
    axiosInstance.interceptors.request.clear();
    // create request interceptor
    axiosInstance.interceptors.request.use(
        async (request) =>
            new Promise(async (resolve, reject) => {
                // execute request
                resolve(request);
            })
    );

    // clear response interceptor
    axiosInstance.interceptors.response.clear();
    // create response interceptor
    axiosInstance.interceptors.response.use(
        async (response) => {
            return response;
        },
        async (error) => {

            const request = error.config;

            if (error.response?.status === 401) {
                if(!request.url.includes(ROUTE_POST_LOGIN) && !request.url.includes(ROUTE_POST_LOGOUT)) {
                    navigate({
                        pathname: "/unauthorized",
                        search: createSearchParams({
                            requestedPage: `${window.location.pathname}${window.location.search}`
                        }).toString()
                    });
                }
                localStorage.removeItem('user');
            }
            else if (error.response?.status === 404) {
                navigate({
                    pathname: "/not-found",
                    search: createSearchParams({
                        requestedPage: `${window.location.pathname}${window.location.search}`
                    }).toString()
                });
            }
            else {
                navigate({
                    pathname: "/internal-error",
                    search: createSearchParams({
                        requestedPage: `${window.location.pathname}${window.location.search}`
                    }).toString()
                });
            }

            return Promise.reject(error);
        }
    );
};